import { APIClient } from "./axiosClient";
const api = new APIClient();

const path = "/location-logs";
const locationLogApi = {
  locationLogs(params: any): Promise<any> {
    const url = `${path}`;
    return api.get(url, params);
  },
  referralLogs(params: any): Promise<any> {
    const url = `/referrals/logs`;
    return api.get(url, params);
  },
  locationLogsNew(params: any): Promise<any> {
    const url = `${path}/migration`;
    return api.get(url, params);
  },
};


export default locationLogApi;
